import {RendererProps} from 'platform/components';

import {EntityResourceIds, FieldValue, TypedAnyValue} from '@dms/api/shared';

export interface AddFieldDefinitionRequestBody {
  name: string;
  hint: string;
  valueType: DefinitionValueType;
  resourceId: string;
  rules: Rule[];
  isRequired?: boolean;
  isNotified?: boolean;
  allowedValues: TypedAnyValue[];
  defaultValue?: boolean | null;
}

interface Rule {
  condition: string;
  constraint: string;
}

export interface UpdateFieldDefinitionRequestBody {
  name: string;
  hint: string;
  isRequired: boolean;
  isNotified: boolean;
  defaultValue?: boolean | null;
}

export interface TenantFieldDefinitionResponseBody {
  id: string;
  resource: {
    id: string;
    name: string;
  };
  makeId: string;
  isRequired?: boolean;
  isNotified?: boolean;
  defaultValue?: boolean;
  name: string;
  hint: string;
  valueType: DefinitionValueType;
  type: string;
  rules: Rule[];
  allowedValues: TypedAnyValue[];
  enumOptions: {
    uuid: string;
    name: string;
    priority: number;
    active: boolean;
  }[];
}

export type AddTenantEnumOptionApiResponse = /** status 201  */ EnumOptionIdResponseBody;
export type AddTenantEnumOptionApiArg = {
  definitionId: string;
  resourceId: string;
  addEnumOptionRequestBody: AddEnumOptionRequestBody;
};
export type RemoveTenantEnumOptionApiResponse = /** status 204  */ void;
export type RemoveTenantEnumOptionApiArg = {
  definitionId: string;
  resourceId: string;
  enumOptionId: string;
};
export type RenameTenantEnumOptionApiResponse = /** status 204  */ void;
export type RenameTenantEnumOptionApiArg = {
  definitionId: string;
  resourceId: string;
  enumOptionId: string;
  renameEnumOptionRequestBody: RenameEnumOptionRequestBody;
};
export type ToggleTenantEnumOptionApiResponse = /** status 204  */ void;
export type ToggleTenantEnumOptionApiArg = {
  definitionId: string;
  resourceId: string;
  enumOptionId: string;
  toggleEnumOptionRequestBody: ToggleEnumOptionRequestBody;
};
export type SetTenantEnumPriorityApiResponse = /** status 204  */ void;
export type SetTenantEnumPriorityApiArg = {
  definitionId: string;
  resourceId: string;
  setEnumPriorityRequestBody: SetEnumPriorityRequestBody;
};

export type SetEnumPriorityRequestBody = {
  options: EnumOptionPriority[];
};

export type EnumOptionIdResponseBody = {
  uuid: string;
};

export type RenameEnumOptionRequestBody = {
  name: string;
};
export type ToggleEnumOptionRequestBody = {
  active: boolean;
};
export type EnumOptionPriority = {
  uuid: string;
  priority: number;
};

// Define request parameter types
export interface TenantFieldDefinitionAddParams {
  body: AddFieldDefinitionRequestBody;
}

export interface TenantFieldDefinitionRemoveParams {
  resourceId: string;
  definitionId: string;
}

export interface TenantFieldDefinitionUpdateParams {
  resourceId: string;
  definitionId: string;
  body: UpdateFieldDefinitionRequestBody;
}

export interface FieldDefinitionListParams {
  resourceId?: string;
  type?: 'tenant' | 'country' | 'make';
}

export interface CustomFieldsSchemaApiArg {
  recordId: string;
  resourceId: EntityResourceIds;
}
export interface CustomFieldsSchemaApiResponse {
  root: RendererProps;
}

export interface CustomFieldsPayloadApiArg {
  recordId: string;
  resourceId: EntityResourceIds;
}

export interface ReorderFieldDefinitionsApiArg {
  resourceId: string;
  items: string[];
}

export type ReorderFieldDefinitionsApiResponse = void;

export interface UpdateCustomFieldsPayloadApiArg {
  recordId: string;
  resourceId: EntityResourceIds;
  fieldValues: FieldValue[];
}

export type UpdateCustomFieldsPayloadApiResponse = FieldValue[];

export type CustomFieldsPayloadApiResponse = FieldValue[];

export type DefinitionValueType =
  | 'integer'
  | 'string'
  | 'money'
  | 'date'
  | 'datetime'
  | 'boolean'
  | 'enum'
  | 'multi_enum'
  | 'decimal';

export type RecordPayloadPatchApiResponse = /** status 204  */ void;

export type RecordPayloadPatchApiArg = {
  resourceId: string;
  recordId: string;
  body: NullableFieldValue[];
};
export type NullableFieldValue = {
  definitionId: string;
  value: TypedAnyValue | null;
};

export type AddEnumOptionRequestBody = {
  name: string;
  priority: number;
};
